import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-servererror',
  template: `
    <div>サーバーエラーが発生しました。</div>
  `,
  styles: ['div { margin-top: 20px; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InternalServerErrorComponent {}
